export default function AppSection() {
  return (
    <section id="app" className="relative py-16 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-200/50 rounded-2xl p-8 md:p-12 border border-background-300/30">
          <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 flex items-center justify-center rounded-2xl bg-primary-500/15">
            <i className="ri-smartphone-line text-3xl md:text-4xl text-primary-400"></i>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3">手机看片</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 max-w-2xl">
              四虎影视大全全面适配移动端浏览，手机、平板随时随地畅享免费全集。无需下载App，浏览器打开即可获得流畅高清观影体验。支持手势控制、记忆播放、夜间模式，追剧从未如此便捷。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 text-xs text-primary-400">
                <i className="ri-android-line"></i> 安卓
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-300/30 border border-background-300/40 text-xs text-foreground-500">
                <i className="ri-apple-line"></i> iOS
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-300/30 border border-background-300/40 text-xs text-foreground-500">
                <i className="ri-computer-line"></i> 网页版
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-300/30 border border-background-300/40 text-xs text-foreground-500">
                <i className="ri-tablet-line"></i> iPad
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}